import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Fragment as _Fragment, vModelText as _vModelText, withModifiers as _withModifiers, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3db25b0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-expanded", "title"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 16 16",
  width: "14",
  height: "14",
  fill: "none",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6 2.2h4M8 2.2V1M5.2 4.4h5.6l.9 7.2H4.3l.9-7.2ZM4.6 13.6h6.8",
    stroke: "currentColor",
    "stroke-width": "1.3",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8 6.4c1 1.1 1.5 1.9 1.5 2.7a1.5 1.5 0 0 1-3 0c0-.8.5-1.6 1.5-2.7Z",
    fill: "currentColor"
  })
], -1 /* HOISTED */))
const _hoisted_3 = {
  class: "nge-lantern-mode",
  role: "radiogroup",
  "aria-label": "What the Lantern lights"
}
const _hoisted_4 = ["aria-checked"]
const _hoisted_5 = ["aria-checked"]
const _hoisted_6 = {
  key: 0,
  class: "nge-lantern-spin",
  "aria-hidden": "true"
}
const _hoisted_7 = {
  key: 1,
  class: "nge-lantern-hint"
}
const _hoisted_8 = {
  key: 2,
  class: "nge-lantern-set",
  title: "How far the light reaches"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Size", -1 /* HOISTED */))
const _hoisted_10 = ["min", "max", "step"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-lantern-unit" }, "µm", -1 /* HOISTED */))
const _hoisted_12 = {
  class: "nge-lantern-set",
  title: "How bright the lit part is"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Flame", -1 /* HOISTED */))
const _hoisted_14 = ["min", "max", "step"]
const _hoisted_15 = {
  key: 1,
  class: "nge-lantern-spooky"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "22",
  height: "22"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7 4h10l4 5-9 11L3 9z",
    fill: "#ffc878"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7 4h10l-2 5H9z",
    fill: "#fff2d6",
    opacity: "0.75"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M3 9h18M7 4l5 16M17 4l-5 16",
    stroke: "#8a5512",
    "stroke-width": "0.8",
    fill: "none",
    opacity: "0.55"
  })
], -1 /* HOISTED */))
const _hoisted_19 = [
  _hoisted_18
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "nge-lantern-bar" }, {
      default: _withCtx(() => [
        ($setup.lantern.on)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              ref: "bar",
              class: _normalizeClass(["nge-lantern", { 'nge-lantern--folded': !$setup.lantern.open }]),
              style: _normalizeStyle($setup.placed),
              role: "group",
              "aria-label": "Lantern mode"
            }, [
              _createElementVNode("span", {
                class: "nge-lantern-grip",
                title: "Drag to move. Double click to put it back.",
                "aria-hidden": "true",
                onPointerdown: $setup.startDrag,
                onDblclick: $setup.resetPlace
              }, "⠿", 32 /* HYDRATE_EVENTS */),
              _createElementVNode("button", {
                type: "button",
                class: "nge-lantern-name",
                "aria-expanded": $setup.lantern.open,
                title: $setup.lantern.open ? 'Fold the Lantern settings away' : 'Show the Lantern settings',
                onClick: _cache[0] || (_cache[0] = $event => ($setup.lantern.open = !$setup.lantern.open))
              }, [
                _hoisted_2,
                _createTextVNode(" Lantern ")
              ], 8 /* PROPS */, _hoisted_1),
              ($setup.lantern.open)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createCommentVNode(" What is lit: the cell round the middle of the view, or only the branch you click (Ames 2026-10-27). "),
                    _createElementVNode("span", _hoisted_3, [
                      _createElementVNode("button", {
                        type: "button",
                        role: "radio",
                        "aria-checked": $setup.lantern.mode === 'cell',
                        class: _normalizeClass({ 'is-on': $setup.lantern.mode === 'cell' }),
                        title: "Light the cell around the middle of your view",
                        onClick: _cache[1] || (_cache[1] = $event => ($setup.lantern.mode = 'cell'))
                      }, "Whole cell", 10 /* CLASS, PROPS */, _hoisted_4),
                      _createElementVNode("button", {
                        type: "button",
                        role: "radio",
                        "aria-checked": $setup.lantern.mode === 'branch',
                        class: _normalizeClass({ 'is-on': $setup.lantern.mode === 'branch' }),
                        title: "Light only the branch you click on",
                        onClick: _cache[2] || (_cache[2] = $event => ($setup.lantern.mode = 'branch'))
                      }, "Clicked branch", 10 /* CLASS, PROPS */, _hoisted_5)
                    ]),
                    ($setup.lantern.mode === 'branch')
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass(["nge-lantern-hint", { 'is-failed': $setup.lanternBranch.status === 'failed' }]),
                          "aria-live": "polite"
                        }, [
                          ($setup.lanternBranch.status === 'finding')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6))
                            : _createCommentVNode("v-if", true),
                          _createTextVNode(_toDisplayString($setup.branchHint), 1 /* TEXT */)
                        ], 2 /* CLASS */))
                      : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Whole cell: the light follows the view until a click pins it (Ames 2026-10-28). "),
                    ($setup.lantern.mode === 'cell')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                          ($setup.lanternBranch.pinnedNm)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode("Pinned. "),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "nge-lantern-mini nge-lantern-follow",
                                  title: "Let the light follow the middle of your view again",
                                  onClick: _cache[3] || (_cache[3] = (...args) => ($setup.unpinLantern && $setup.unpinLantern(...args)))
                                }, "Follow view")
                              ], 64 /* STABLE_FRAGMENT */))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString($setup.isTouchRef ? 'Tap' : 'Ctrl + click') + " the cell to place the light", 1 /* TEXT */)
                              ], 64 /* STABLE_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true),
                    ($setup.lantern.mode === 'cell')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_8, [
                          _hoisted_9,
                          _withDirectives(_createElementVNode("input", {
                            type: "range",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.lantern.sizeUm) = $event)),
                            min: $setup.L.sizeUm.min,
                            max: $setup.L.sizeUm.max,
                            step: $setup.L.sizeUm.step,
                            onKeydown: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_10), [
                            [
                              _vModelText,
                              $setup.lantern.sizeUm,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _createElementVNode("output", null, [
                            _createTextVNode(_toDisplayString($setup.lantern.sizeUm) + " ", 1 /* TEXT */),
                            _hoisted_11
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("label", _hoisted_12, [
                      _hoisted_13,
                      _withDirectives(_createElementVNode("input", {
                        type: "range",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($setup.lantern.flame) = $event)),
                        min: $setup.L.flame.min,
                        max: $setup.L.flame.max,
                        step: $setup.L.flame.step,
                        onKeydown: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_14), [
                        [
                          _vModelText,
                          $setup.lantern.flame,
                          void 0,
                          { number: true }
                        ]
                      ]),
                      _createElementVNode("output", null, _toDisplayString($setup.lantern.flame) + "%", 1 /* TEXT */)
                    ])
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              ($setup.showGhost)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["nge-lantern-ghost", { 'is-on': $setup.spooky.on }]),
                      title: "Call a ghost",
                      "aria-label": "Call a ghost",
                      onClick: _cache[8] || (_cache[8] = (...args) => ($setup.callGhost && $setup.callGhost(...args)))
                    }, [
                      _createElementVNode("img", {
                        src: $setup.ghostIcon,
                        alt: "",
                        draggable: "false"
                      }, null, 8 /* PROPS */, _hoisted_16)
                    ], 2 /* CLASS */),
                    _createCommentVNode(" The reaper is held back from players for now: admins only, to try him out. "),
                    ($setup.backend.showAdminUi)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "nge-lantern-ghost nge-lantern-ghost--reaper",
                          title: "Call the reaper (admins only, for testing)",
                          "aria-label": "Call the reaper",
                          onClick: _cache[9] || (_cache[9] = (...args) => ($setup.callTheReaper && $setup.callTheReaper(...args)))
                        }, [
                          _createElementVNode("img", {
                            src: $setup.reaperIcon,
                            alt: "",
                            draggable: "false"
                          }, null, 8 /* PROPS */, _hoisted_17)
                        ]))
                      : _createCommentVNode("v-if", true),
                    ($setup.spooky.on)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          type: "button",
                          class: "nge-lantern-mini",
                          title: "Send them away",
                          "aria-label": "Send them away",
                          onClick: _cache[10] || (_cache[10] = (...args) => ($setup.shoo && $setup.shoo(...args)))
                        }, "shoo"))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("button", {
                type: "button",
                class: "nge-lantern-off",
                title: "Turn the Lantern off (Shift+N)",
                "aria-label": "Turn the Lantern off",
                onClick: _cache[11] || (_cache[11] = $event => ($setup.lantern.on = false))
              }, "×")
            ], 6 /* CLASS, STYLE */))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }),
    _createCommentVNode(" The gem where the branch was clicked: it glows while the branch is\n         found, and goes once it lights (Ames 2026-10-27). "),
    ($setup.lantern.on && $setup.lanternBranch.marker)
      ? (_openBlock(), _createElementBlock("div", {
          key: $setup.lanternBranch.marker.at,
          class: _normalizeClass(["nge-lantern-gem", 'is-' + $setup.lanternBranch.marker.state]),
          style: _normalizeStyle({ left: $setup.lanternBranch.marker.x + 'px', top: $setup.lanternBranch.marker.y + 'px' }),
          "aria-hidden": "true"
        }, _hoisted_19, 6 /* CLASS, STYLE */))
      : _createCommentVNode("v-if", true)
  ]))
}